import { createSlice } from "@reduxjs/toolkit";

const authSlice = createSlice({
  name: "auth",
  initialState: {
    token: null,
    sponserId: null,
    name: null,
    email: null,
    profileImageUrl: null,
    notifications: null,
  },
  reducers: {
    setCredentials: (state, action) => {
      const {
        accessToken,
        sponserId,
        name,
        email,
        profileImageUrl,
        notifications,
      } = action.payload;
      state.token = accessToken;
      state.sponserId = sponserId;
      state.name = name;
      state.email = email;
      state.profileImageUrl = profileImageUrl;
      state.notifications = notifications;
    },
    logout: (state, action) => {
      state.token = null;
      state.sponserId = null;
      state.name = null;
      state.email = null;
      state.profileImageUrl = null;
    },
    setImageUrl: (state, action) => {
      const { profileImageUrl } = action.payload;
      state.profileImageUrl = profileImageUrl;
    },
    setNotifications: (state, action) => {
      const { notifications } = action.payload;
      state.notifications = notifications;
    },
  },
});

export const { setCredentials, logout, setImageUrl, setNotifications } =
  authSlice.actions;

export default authSlice.reducer;

export const selectCurrentToken = (state: any) => state.auth.token;
export const selectSponserID = (state: any) => state.auth.sponserId;
export const selectSponserName = (state: any) => state.auth.name;
export const selectSponserEmail = (state: any) => state.auth.email;
export const selectImageUrl = (state: any) => state.auth.profileImageUrl;
export const selectUserData = (state: any) => ({
  token: state.auth.token,
  name: state.auth.name,
  sponserId: state.auth.sponserId,
  email: state.auth.email,
  profileImageUrl: state.auth.profileImageUrl,
  notifications: state.auth.notifications,
});
